var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKatakana = function SvgKatakana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.006,
    height: 11,
    viewBox: "0 0 72.006 9.7"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2 5c-.3 3.1-2.7 4.3-5.1 4.5V8.1c2.1-.3 3.3-1.3 3.5-3.2H0V3.6h4.6V2.1H.8V.7h4.1A3.718 3.718 0 0 0 7.2.2H9C8.7 1.3 7.5 1.8 6.2 2v1.6h3.3V5ZM16.8 9.3V8h5.8V6H17V4.7h5.6V3.1h-5.8V1.8H24v7.5ZM37.2 6.7l.3 3H36l-.3-3h-4.3V5.3h4.1l-.2-2.1h-3.6V1.7h3.5L35.1 0h1.5l.2 1.7h3.9v1.4h-3.8l.2 2.1h4.1v1.4h-4ZM47.7 9.2V7.8h4.8l.5-4.6h-4.3V1.9h5.9l-.6 6h2v1.3ZM67.3 6.3a5.559 5.559 0 0 1-3.8 3.2V8.1c1.8-.7 2.9-2 2.9-4.6v-.6h1.4v.7a6.158 6.158 0 0 1-.1 1.3A3.413 3.413 0 0 0 70.3 2h-7.2V.5H72v.3a5.275 5.275 0 0 1-4.7 5.5"
  }))));
};

export default SvgKatakana;